import React, { useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie'

import { Button } from '../../../helpers';
import UserProfile from '../../../common/UserProfile';
import { logoutChannel } from '../../../common/logoutChannel';

import { updateSessionRole, removeSession } from '../../../services/api/auth';
import { removeToken } from '../../../services/redux/reducers/user/user'

import "../index.css"

import { checkPermissions, getFullName } from '../../../utils';


const ProfileBar = () => {
    const op = useRef(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const rolesList = useSelector((state) => state.userDetails.rolesList)
    const activeRoleId = useSelector((state) => state.userDetails.activeRoleId)
    const userDetails = useSelector((state) => state.userDetails)
    const userNameDetails = useSelector((state) => state.userDetails.userNameDetails)
    const menuData = useSelector(state => state.menu.menuData)
    
    const activeRole = rolesList?.find(role => role.userRoleId === activeRoleId)

    const handleLogout = async () => {
        logoutChannel.postMessage("Logout")

        Cookies.remove('jwtTokenClient')
        await removeSession()
 
        dispatch(removeToken())
        navigate('/login')
    }

    const handleRoleChange = async (selectedRole) => {  
        if(selectedRole.userRoleId === activeRoleId){
            return
        }
        
        const relatedMenuItem = menuData.find(eachMenuItem => eachMenuItem.clientPath === window.location.pathname)

        if(relatedMenuItem){
            const updateSessionRoleRes = await updateSessionRole(selectedRole.userRoleId, selectedRole.pmCompanyId)
            console.log("updateSessionRoleRes", updateSessionRoleRes)
            const permParams = {
                reqPermActionIds: [relatedMenuItem.permActionId],
                activeCompanyRoleId: selectedRole.companyRoleId,
                userRoleId: selectedRole.userRoleId,
                permExceptions: userDetails.permExceptions,
                permGeo: userDetails.permGeo,
                permActions: userDetails.permActions,
                permRoles: userDetails.permRoles
            }
            const { isPermitted } = checkPermissions(permParams)
            console.log("relatedMenuItem", isPermitted)
            if(!isPermitted){
                window.location.href = '/'
            } else {
                window.location.reload()
            }
        } 
        else {
            window.location.href = '/'
        }
    }

    const handleViewProfile = async (e) => {
        navigate(`/editUser/${userDetails.userId}`)
        op.current.toggle(e)
    }

    let location = ""
    if(activeRole?.branchId === 0){
        location = userDetails.PMCompanyDetails.countryDetails?.countryName
    } else {
        location = activeRole?.branchName
    }

    return (
        <>
            <div className='flex flex-row mr-2 profile-bar'>
                <div className='flex flex-row align-items-center cursor-pointer' onClick={(e) => op.current.toggle(e)}>
                    { userNameDetails.firstName && <UserProfile userNameDetails={userNameDetails}/> }
                    <div className="md:flex flex-column justify-content-center mx-2 hidden md:block">
                        <span className='nav-profile-name'>
                            {userNameDetails.firstName} {userNameDetails.lastName}
                        </span>
                        <span className='nav-company-role'>{activeRole?.companyRoleName} ({location})</span>
                    </div>
                    <span className='mr-2'><i className="pi pi-angle-down ml-1" style={{ fontSize: '0.8rem', cursor: "pointer"}}></i></span>
                </div>
                
                <OverlayPanel className="profile-card" ref={op} appendTo="self" style={{ borderRadius: "5px"}}>
                    <div >
                        <div className=''>
                        <div className="profile-header">
                            <div className="svg-background">
                                {/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 240"><path fill="#fff" fill-opacity="1" d="M0,160L40,149.3C80,139,160,117,240,138.7C320,160,400,224,480,224C560,224,640,160,720,128C800,96,880,96,960,117.3C1040,139,1120,181,1200,176C1280,171,1360,117,1400,90.7L1440,64L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path></svg>*/}
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 30 510 240">
                                        <path fill="#fff" fill-opacity="1" d="M0,160L40,149.3C80,139,160,117,240,138.7C320,160,400,224,480,224C560,224,640,160,720,128C800,96,880,96,960,117.3C1040,139,1120,181,1200,176C1280,171,1360,117,1400,90.7L1440,64L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z">
                                        </path>
                                    </svg>
                            </div>
                            <div className="profile-info">
                                {
                                    userNameDetails.profileImg ? 
                                    <img src={userNameDetails.profileImg} alt='profile image' className="profile-img"/> 
                                    : 
                                    <img src='https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png' alt='profile image' className="profile-img"/>
                                }
                                <h2 className='mt-2'>{getFullName(userNameDetails.firstName, userNameDetails.lastName)}</h2>
                                <p className='my-1'>{userNameDetails.emailId}</p>
                            </div>
                        </div>
                        <div className='container2 mt-1'>
                            {rolesList?.map(eachRole => {
                                const activeRoleBulletClassName = eachRole.userRoleId === activeRoleId ? 'diamond' : 'diamond-normal'

                                return(
                                    <div key={eachRole.userRoleId} style={{cursor: "pointer"}}>
                                        <div className={`flex flex-column px-2 py-1 p-card mb-1 role-card ${eachRole.userRoleId === activeRoleId && "role-card-active"}`} onClick={() => handleRoleChange(eachRole)}>
                                            <div className="flex flex-row">
                                                <span className={`${activeRoleBulletClassName} mt-3 p-1 m-1`}></span>
                                                <p className="description p-1 m-1 w-full">
                                                    {eachRole.companyName} <br/>
                                                    {eachRole.branchName} {eachRole.branchName ? "-" : ""} {eachRole.companyRoleName}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            )}
                        </div>
                        <div className='footer-container flex flex-row align-items-center justify-content-center'>
                            <Button className="hover:text-teal-700 mr-3" style={{color: "#567274"}} icon="pi pi-sign-out" label="Log out"  onClick={handleLogout} text/>
                            <Button label="View Profile" style={{color: "#567274", fontSize: "13px"}} className="hover:text-teal-700 ml-3"  onClick={handleViewProfile} text />
                        </div>
                        </div>
                    </div>
                </OverlayPanel>
            </div>
        </>
    )
}

export default ProfileBar
